import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import teamSave, { TeamSaveModel } from "@/store/models/teams/addTeam";
import { toaster } from "@/utilities/toaster";
import TeamModule from "@/store/modules/team.module";
import { Guid } from "guid-typescript";
import Switches from "vue-switches";
let EditTeam = /** @class */ (() => {
    let EditTeam = class EditTeam extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.updateteam = new teamSave(new TeamSaveModel());
            this.title = "Edit Team";
            this.ctaButtons = [
                {
                    routeName: "Teams",
                },
            ];
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Teams",
                    href: "#",
                },
                {
                    text: "Edit Team",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
        }
        // Computed
        get teamone() {
            return TeamModule.team;
        }
        created() {
            var teamId = Guid.parse(this.$route.params.teamId);
            TeamModule.GetTeamById(teamId).then((response) => {
                this.pageIsLoading = false;
            });
        }
        updateTeam() {
            this.validate("addTeamObserver").then((res) => {
                if (res) {
                    this.updateteam = {
                        teamId: this.teamone.teamId,
                        teamName: this.teamone.teamName,
                        description: this.teamone.description,
                        isActive: this.teamone.isActive,
                        createdBy: this.teamone.teamId,
                        createdOn: new Date(),
                    };
                    TeamModule.saveTeam(this.updateteam).then((res) => {
                        if (res) {
                            toaster.ShowSuccess(`Team was updated successfully.`);
                            this.$router.push({ name: "Teams" });
                        }
                        else {
                            toaster.ShowError("Unable to update Team details.");
                        }
                    });
                }
            });
        }
    };
    EditTeam = __decorate([
        Component({
            name: "TeamsListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                Switches,
            },
        })
    ], EditTeam);
    return EditTeam;
})();
export default EditTeam;
